<template>
  <div class="product-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入藏家手机号查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!--藏品列表-->
    <Drawer :title="title"
            v-model="showCollectionModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Table :columns="collectionlist"
             :data="collectiontablelist"
             :loading="dataloading"></Table>
    </Drawer>
    <!--转赠记录列表-->
    <Drawer :title="title"
            v-model="showTurnModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Table :columns="turnlist"
             :data="turntablelist"
             :loading="dataloading"></Table>
    </Drawer>
    <!--粉丝列表-->
    <Drawer :title="title"
            v-model="showFensiModalStatus"
            width="540"
            :mask-closable="false"
            :styles="styles">
      <Table :columns="fensilist"
             :data="fensitablelist"
             :loading="dataloading"></Table>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: 'product-list',
  data () {
    return {
      styles: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      loading: true,
      dataloading: true,
      showCollectionModalStatus: false,
      showTurnModalStatus: false,
      showFensiModalStatus: false,
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
      },
      list: [
        {
          title: 'UUID',
          key: 'collector_uuid',
          fixed: 'left',
          width: 300
        },
        {
          title: '藏家信息',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('div', [
              h('p', {
                style: {
                  color: '#8a6d3b'
                }
              }, '手机号:' + params.row.user.username),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '昵称:' + params.row.userdata.nickname),
              h('p', {
                style: {
                  color: '#777'
                }
              }, '哈希值:' + params.row.collector_blockchain_id)
            ]);
          }
        },
        {
          title: '账户',
          key: 'money',
          Width: 150,
          render: (h, params) => {
            return h('div', [
              h('span', {
              }, params.row.money)
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 300,
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.showcollectionlist(params.row.collector_uuid)
                  }
                }
              }, '我的藏品'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.showattentionlist(params.row.collector_uuid)
                  }
                }
              }, '我的粉丝'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.showturnlist(params.row.collector_uuid)
                  }
                }
              }, '转赠记录'),
            ]);

          }
        }
      ],
      tablelist: [],
      collectionlist: [
        {
          title: '哈希值',
          key: 'blockchain_id',
          fixed: 'left',
          width: 300
        },
        {
          title: '名称',
          key: 'name',
          width: 200
        },
        {
          title: '来源',
          key: 'sorce',
          Width: 150,
        }
      ],
      collectiontablelist: [],
      turnlist: [
        {
          title: '哈希值',
          key: 'blockchain_id',
          fixed: 'left',
          width: 300
        },
        {
          title: '名称',
          key: 'name',
          width: 200
        },
        {
          title: '接收人',
          key: 'receiver',
          Width: 150,
        },
        {
          title: '接收状态',
          key: 'receive_status',
          Width: 150,
          render: (h, params) => {
            return h('div', [
              h('span', {
              }, params.row.receive_status == 0 ? "未接收" : "已接收")
            ]);
          }
        },
        {
          title: '接收时间',
          key: 'receive_at',
          Width: 150,
        },
      ],
      turntablelist: [],
      fensilist: [
        {
          title: '手机号',
          key: 'username',
          fixed: 'left',
          width: 300
        },
        {
          title: '名称',
          key: 'nickname',
          width: 200
        },
      ],
      fensitablelist: [],
    }
  },
  created: function () {
    this.getTableList();

  },
  components: {
  },

  methods: {

    getTableList: function () {
      this.$api.collector.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.collector.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    showcollectionlist (uuid) {
      this.showCollectionModalStatus = !this.showCollectionModalStatus;
      var ps = {
        collector_uuid: uuid,
      };
      this.$api.collector.collectionlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.collectiontablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    showturnlist (uuid) {
      this.showTurnModalStatus = !this.showTurnModalStatus;
      var ps = {
        collector_uuid: uuid,
      };
      this.$api.collector.turnloglist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.turntablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    showattentionlist (uuid) {
      this.showFensiModalStatus = !this.showFensiModalStatus;
      var ps = {
        collector_uuid: uuid,
      };
      this.$api.collector.attentionlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.fensitablelist = res.result;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
</script>
